// https://create-react-app.dev/docs/adding-custom-environment-variables
export const ROOT_DOMAIN = process.env.REACT_APP_ROOT_DOMAIN;
export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;
export const SEEK_DOMAIN = process.env.REACT_APP_SEEK_DOMAIN;
export const CATALOG_DOMAIN = process.env.REACT_APP_CATALOG_DOMAIN;
export const SIDEKICK_DOMAIN = `app.${ROOT_DOMAIN}`;
export const PROTOCOL = process.env.REACT_APP_PROTOCOL;
export const API_ROOT = `${PROTOCOL}://${API_DOMAIN}/api`;
export const CHART_ROOT = `${PROTOCOL}://${API_DOMAIN}`;
export const SEEK_ROOT = `${PROTOCOL}://${SEEK_DOMAIN}`;
export const CATALOG_ROOT = `${PROTOCOL}://${CATALOG_DOMAIN}`;
export const SIDEKICK_ROOT = `${PROTOCOL}://${SIDEKICK_DOMAIN}`;

export const SEGMENT_API_KEY = process.env.REACT_APP_SEGMENT_API_KEY;

export const ALGOLIA_APPLICATION_ID = process.env.REACT_APP_ALGOLIA_APPLICATION_ID;
export const ALGOLIA_API_KEY = process.env.REACT_APP_ALGOLIA_API_KEY;
export const ALGOLIA_DIMENSIONS_INDEX = process.env.REACT_APP_ALGOLIA_DIMENSIONS_INDEX;

export const ROOT = '';
export const SUGGESTED_SELECTION_MAX = 0;
